var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-skeleton-loading"},[_c('v-row',{staticClass:"mt-2 mb-2"},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12","align":"center"}},[_c('v-skeleton-loader',{attrs:{"type":"table"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }